export const DEFAULT_UPLOAD_CATEGORY_ID = 4

export const UNSUPPORTED_FILE_RESPONSE_MESSAGE = 'File was uploaded incorrectly!'
